<div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary h-100">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-5 col-xl-4 my-5">
        <h1 class="display-4 text-center mb-3">
          Passwort ändern
        </h1>

        <div class="card">

          <!--<div class="card-header">
            <h4 class="card-header-title">Passwort ändern</h4>
          </div>-->

          <div class="card-body">

            <div class="row">

              <div class="col-12">

                <!-- Password -->
                <!--<div class="form-group">-->
                <!-- Label -->
                <!--<label>
                  Passwort
                </label>-->
                <!-- Input -->
                <!--<input name="oldPassword" [(ngModel)]="oldPassword" type="password" class="form-control">-->
                <!--</div>-->
                <!-- New password -->
                <div class="form-group">

                  <!-- Label -->
                  <label>
                    Neues Passwort
                  </label>

                  <!-- Input -->
                  <!--[pattern]="pwdPattern" #pwd="ngModel"-->
                  <input name="newPassword" [(ngModel)]="newPassword" type="password" class="form-control" minlength="{{pwdMinLength}}" [pattern]="pwdPattern" #pwd="ngModel" autofocus>
                  <div *ngIf="pwd.errors" class="m-t-5">
                    <div class="alert alert-danger" *ngIf="(pwd.errors.minlength || pwd.errors.pattern)">
                      {{pwdErrorMsg}}
                    </div>
                  </div>
                  <!--<div class="alert alert-danger" role="alert" [hidden]="!minLengthError">
                    <h4 class="alert-heading mb-0">{{minLengthError}}</h4>
                  </div>
                  <div class="alert alert-danger" *ngIf="pwd.errors && pwd.errors.pattern">
                    Password must contain 1 Uppercase,1 Lowercase & 1 Special character
                  </div>-->
                </div>

                <!-- Confirm new password -->
                <div class="form-group">

                  <!-- Label -->
                  <label>
                    Neues Passwort bestätigen
                  </label>

                  <!-- Input -->
                  <input name="newPasswordRetype" [(ngModel)]="newPasswordRetype" type="password" class="form-control">

                </div>

                <div class="alert alert-success" role="alert" [hidden]="!changePasswordSuccess">
                  <h4 class="alert-heading mb-0">Ihr Passwort wurde aktualisiert.</h4>
                </div>

                <div class="alert alert-danger" role="alert" [hidden]="!changePasswordError">
                  <h4 class="alert-heading mb-0">{{changePasswordError}}</h4>
                </div>

                <div class="alert alert-danger" role="alert" [hidden]="!mandatoryMsg">
                  {{mandatoryMsg}}
                </div>

              <div class="text-right">

                <!-- Submit -->
                <button (click)="changePassword()" class="btn btn-primary">
                  {{submitted ? 'Passwort wird aktualisiert' : 'Passwort aktualisieren' }}
                </button>

              </div>

              </div>
            </div>
            <!-- / .row -->


          </div>
          <!-- / .card-body -->

        </div>
      </div>
    </div>
  </div>
</div>
